import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import * as Colors from '@material-ui/core/colors'
const selectedColor = Colors.lightGreen['700']

const styles = theme => ({
  flatButton: {
    backgroundColor: theme.palette.common.white
  },
  flatButtonWhite: {
    '&:disabled': {
      color: 'white',
      backgroundColor: selectedColor
    }
  },
  flatButtonCurrent: {
    '&:disabled': {
      color: 'white',
      backgroundColor: theme.palette.secondary.dark
    }
  }
})

export default withStyles(styles)(
  class SelectableBarComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      bar: PropTypes.object.isRequired,
      selectable: PropTypes.bool.isRequired,
      isSelected: PropTypes.bool,
      onSelect: PropTypes.func.isRequired,
      currentTransaction: PropTypes.object
    }
    static defaultProps = {
      isSelected: false
    }
    handleSelectTable = e => {
      this.props.onSelect(this.props.bar)
    }
    render() {
      const {
        classes,
        isSelected,
        bar,
        selectable,
        currentTransaction
      } = this.props
      const isCurrent =
        currentTransaction &&
        bar.currentTransaction &&
        currentTransaction.key === bar.currentTransaction.key
      let classButton = isSelected
        ? classes.flatButtonWhite
        : classes.flatButton
      if (isCurrent) {
        classButton = classes.flatButtonCurrent
      }
      return (
        <Paper elevation={!isCurrent || selectable || !isSelected ? 5 : 1}>
          <Button
            variant="raised"
            color="inherit"
            disabled={
              isCurrent || !selectable || !bar.currentTransaction.sale_id
            }
            className={classButton}
            onClick={this.handleSelectTable}>
            {bar.name}
          </Button>
        </Paper>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/SelectionTabsComponent/SelectableBarComponent.js